import React, { useEffect, useMemo, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const EmbedPromptDialog = ({ open, onClose, onConfirm, embedType }) => {
  const [value, setValue] = useState('');
  const [mode, setMode] = useState('url'); // 'url' | 'embed'

  useEffect(() => {
    if (open) {
      setValue('');
      setMode('url');
    }
  }, [open, embedType]);

  const isFacebook = embedType === 'facebook';
  const isIframe = embedType === 'iframe';
  const hasModeToggle = isFacebook || isIframe;

  const title = useMemo(() => {
    if (isFacebook) {
      return mode === 'url'
        ? "Veuillez saisir l'URL du post / live Facebook :"
        : "Veuillez coller le code intégré <iframe> fourni par Facebook :";
    }
    if (isIframe) {
      return mode === 'url'
        ? "Veuillez saisir l'URL de la page à intégrer :"
        : "Veuillez coller le code intégré <iframe> :";
    }
    switch (embedType) {
      case 'instagram':
        return "Veuillez saisir l'URL du post Instagram :";
      case 'twitter':
        return "Veuillez saisir l'URL du tweet :";
      default:
        return "Saisissez l'URL";
    }
  }, [embedType, isFacebook, isIframe, mode]);

  const fieldLabel = useMemo(() => {
    if (isFacebook) {
      return mode === 'url' ? "URL Facebook" : "Code intégré <iframe>";
    }
    if (isIframe) {
      return mode === 'url' ? "URL" : "Code intégré <iframe>";
    }
    return "URL";
  }, [embedType, isFacebook, isIframe, mode]);

  const placeholder = useMemo(() => {
    if (isFacebook) {
      return mode === 'url'
        ? "https://www.facebook.com/..."
        : '<iframe src="https://www.facebook.com/plugins/video.php?href=..."></iframe>';
    }
    if (isIframe) {
      return mode === 'url'
        ? "https://votre-page-a-integrer..."
        : '<iframe src="https://..."></iframe>';
    }
    switch (embedType) {
      case 'instagram':
        return 'https://www.instagram.com/p/...';
      case 'twitter':
        return 'https://twitter.com/.../status/...';
      default:
        return 'https://...';
    }
  }, [embedType, isFacebook, isIframe, mode]);

  const inputType =
    (isFacebook || isIframe) && mode === 'embed'
      ? 'text'
      : 'url';

  const handleConfirm = () => {
    const trimmed = value.trim();
    if (trimmed) {
      onConfirm({ value: trimmed, mode });
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {hasModeToggle && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <Button
              size="small"
              variant={mode === 'url' ? 'contained' : 'outlined'}
              onClick={() => setMode('url')}
            >
              URL
            </Button>
            <Button
              size="small"
              variant={mode === 'embed' ? 'contained' : 'outlined'}
              onClick={() => setMode('embed')}
            >
              Code intégré &lt;iframe&gt;
            </Button>
          </div>
        )}

        <TextField
          autoFocus
          margin="dense"
          label={fieldLabel}
          type={inputType}
          fullWidth
          variant="standard"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          multiline={(isFacebook || isIframe) && mode === 'embed'}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={handleConfirm} disabled={!value.trim()}>
          Insérer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmbedPromptDialog;